import { render, staticRenderFns } from "./NoSidebar.vue?vue&type=template&id=dcf33518&scoped=true&"
import script from "./NoSidebar.vue?vue&type=script&lang=js&"
export * from "./NoSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NoSidebar.vue?vue&type=style&index=0&id=dcf33518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf33518",
  null
  
)

export default component.exports